import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[ngx-datatable-row-detail-template]'
})
export class DatatableRowDetailTemplateDirective {
  template = inject<TemplateRef<unknown>>(TemplateRef);

}
